import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['blacksmith', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3,-3h1v0.5h-1zM-3,-2.5h0.5v2h-0.5zM-1,-2.5h1v0.5h-1zM-0.5,-2h1v0.5h-1zM-3,-0.5h1v0.5h-1zM-1.5,0h1v0.5h-1z',
    },
    {
      paint: [
        ['blacksmith', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M2,-7h0.5v0.5h-0.5zM-2,-3h0.5v0.5h-0.5zM2,-3h1v0.5h-1zM-2.5,-2.5h0.5v0.5h-0.5zM1,-2.5h2v0.5h-2zM-1,-2h0.5v1h-0.5zM0.5,-2h2.5v0.5h-2.5zM-2.5,-1.5h0.5v1h-0.5zM1.5,-1.5h1.5v0.5h-1.5zM1,-1h2v0.5h-2zM-2,-0.5h0.5v0.5h-0.5zM0.5,-0.5h2.5v0.5h-2.5zM0.5,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'roofA',
      d: 'M-1.5,-5.5h1v0.5h-1zM-2.5,-5h3.5v0.5h-3.5zM-3,-4.5h4v0.5h-4zM-3.5,-4h4.5v0.5h-4.5zM2.5,-4h1v0.5h-1zM-3.5,-3.5h7v0.5h-7zM-1.5,-3h3.5v0.5h-3.5zM0,-2.5h1v0.5h-1z',
    },
    {
      paint: 'chimney',
      d: 'M1,-7h1v0.5h-1zM2.5,-7h0.5v0.5h-0.5zM1,-6.5h2v2.5h-2zM1,-4h1.5v0.5h-1.5zM-2,-2h0.5v0.5h-0.5zM-2,-1h1v0.5h-1z',
    },
    { paint: 'shadow', d: 'M-2,-2.5h1v0.5h-1zM-2.5,-2h0.5v0.5h-0.5zM-1.5,-0.5h1v0.5h-1z' },
    { paint: 'torchFlame', d: 'M-1.5,-2h0.5v0.5h-0.5zM-2,-1.5h1v0.5h-1z' },
    { paint: 'anvil', d: 'M-1,-1h2v0.5h-2zM-0.5,-0.5h1v0.5h-1z' },
    {
      paint: [
        ['anvil', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-0.5,-1.5h2v0.5h-2zM-0.5,0h1v0.5h-1z',
    },
    { paint: 'smoke', d: 'M1.5,-8h1.5v0.5h-1.5zM2,-7.5h1v0.5h-1z' },
  ],
  pixels: 153,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
